import { lazy } from 'react'

import i18n from 'live/services/i18n'

import { fracEventsButtonRegistry } from 'plugin-joblog/shared/lib/frac-events-button-registry'
import registerOperationStatusButton from './registers/OperationStatusRegister'
import registerStageOverviewHeaderButton from './registers/StageReviewAndApprovalRegister'
import registerApprovalOverviewSidebarButton from './registers/ApprovalOverviewSidebarRegister'
import registerApprovalOverviewRelatedPagesButton from './registers/ApprovalOverviewRelatedPagesRegister'

import './i18n'
import { addRoute } from './PostStageReport/helpers/addRouteHelper'
import { canAccessPSR } from './permissions/permissions'

export const FRAC_EVENTS_ALIAS = 'frac-events'
export const POST_STAGE_REPORT_ALIAS = 'post-stage-report'

addRoute(
    `/${FRAC_EVENTS_ALIAS}/${POST_STAGE_REPORT_ALIAS}`,
    lazy(() => import('./PostStageReport')),
    FRAC_EVENTS_ALIAS
)

addRoute(
    `/${FRAC_EVENTS_ALIAS}/${POST_STAGE_REPORT_ALIAS}/{crewId}/{padId}/{wellId}/{stageNumber}`,
    lazy(() => import('./PostStageReport')),
    FRAC_EVENTS_ALIAS
)

addRoute(
    `/${FRAC_EVENTS_ALIAS}/${POST_STAGE_REPORT_ALIAS}/{crewId}/run/{stageUid}`,
    lazy(() => import('./PostStageReport')),
    FRAC_EVENTS_ALIAS,
    { isRun: true }
)

registerOperationStatusButton(FRAC_EVENTS_ALIAS, POST_STAGE_REPORT_ALIAS)
registerStageOverviewHeaderButton(FRAC_EVENTS_ALIAS, POST_STAGE_REPORT_ALIAS)
registerApprovalOverviewSidebarButton(FRAC_EVENTS_ALIAS, POST_STAGE_REPORT_ALIAS)
registerApprovalOverviewRelatedPagesButton(FRAC_EVENTS_ALIAS, POST_STAGE_REPORT_ALIAS)

if (canAccessPSR()) {
    fracEventsButtonRegistry.register({
        title: i18n('Post Stage Report'),
        url: `#/${FRAC_EVENTS_ALIAS}/${POST_STAGE_REPORT_ALIAS}`,
        order: 2
    })
}
